// extracted by mini-css-extract-plugin
export var activeNavItem = "header-module--active-nav-item--gxwIw";
export var booksSubmenu = "header-module--books-submenu--8XgOJ";
export var checkbox = "header-module--checkbox--yHDm6";
export var chevron = "header-module--chevron--DoGO2";
export var header = "header-module--header--pyZa0";
export var label = "header-module--label--g89AG";
export var logo = "header-module--logo--ScKHc";
export var navItem = "header-module--nav-item--moZp2";
export var navList = "header-module--nav-list--xbsvz";
export var submenu = "header-module--submenu--Apmbq";
export var submenuTrigger = "header-module--submenu-trigger--RewVZ";